module.exports = __webpack_public_path__ + "static/media/market_mix.717e057f.png";